angular.module('bmsApp.merrymaids.job')
	.controller('MMJobSaveCtrl', [
		'$state',
		'$stateParams',
		'$scope',
		'$q',
		'$filter',
		'$ngBootbox',
		'$timeout',
		'notify',
		'TaxHelperSvc',
		'MMJobSvc',
		'MMDiscountSvc',
		'EnquirySvc',
		'CustomerSvc',
		'SalesPipelineSvc',
		'SiteSvc',
		'LicenseOptionsSvc',
		'MMCleaningFrequencySvc',
		'QuoteStatusSvc',
		'MMHouseTemplateSvc',
		'MMRoomTypeSvc',
		'MMCleaningInstructionSvc',
		'SecurityTypeSvc',
		'EmployeeTeamSvc',
		'PaymentTypeSvc',
		'ProximitySvc',
		function ($state,
				  $stateParams,
				  $scope,
				  $q,
				  $filter,
				  $ngBootbox,
				  $timeout,
				  notify,
				  TaxHelperSvc,
				  MMJobSvc,
				  MMDiscountSvc,
				  EnquirySvc,
				  CustomerSvc,
				  SalesPipelineSvc,
				  SiteSvc,
				  LicenseOptionsSvc,
				  MMCleaningFrequencySvc,
				  QuoteStatusSvc,
				  MMHouseTemplateSvc,
				  MMRoomTypeSvc,
				  MMCleaningInstructionSvc,
				  SecurityTypeSvc,
				  EmployeeTeamSvc,
				  PaymentTypeSvc,
				  ProximitySvc) {

			// MMDiscountSvc.typeOptions()
			// 	.then((response) => {
			// 		console.info('LOADED DISCOUNT TYPE OPTIONS');
			// 		console.info(response);
			// 		let discountType = response.data.discount_type_collection[0];
			// 		MMDiscountSvc.calculateDiscount({
			// 			discount_type: discountType,
			// 			discount_value: 25,
			// 			gross: 250,
			// 			vat_rate: 20,
			// 		})
			// 			.then((response) => {
			// 				console.info('CALCULATED GROSS DISCOUNT');
			// 				console.info(response);
			// 			});
			// 	});

			var protos = {
				job: function () {
					return {
						proforma_quote: false,
						converted: false,
						converting: false,
						advantage_programme_period: 0,
						job_rooms: [
							protos.jobRoom()
						],
						clean_rotation_count: 1,
						deep_clean_rotation_count: 1,
						job_duration_hours: 0,
						job_duration_mins: 0,
						job_duration_first_in_hours: 0,
						job_duration_first_in_mins: 0,
						job_clean_frequencies: [
							protos.jobCleanFrequency()
						],
						fuel_surcharge: 0,
						preferred_cleaning_time: new moment()
					};
				},
				jobCleanFrequency: function () {
					return {
						first_clean_net: 0,
						first_clean_vat: 0,
						first_clean_gross: 0,
						clean_net: 0,
						clean_vat: 0,
						clean_gross: 0,
						discount_value: 0,
						discount_description: '',
						discount_net: 0,
						discount_vat: 0,
						discount_gross: 0,
						first_clean_discount_net: 0,
						first_clean_discount_vat: 0,
						first_clean_discount_gross: 0,
						expanded: true
					};
				},
				jobRoom: function () {
					return {
						room: null,
						instructions: [],
						clean_rotations: [
							{
								rotation_no: 1,
								clean: false
							}
						],
						deep_clean_rotations: [
							{
								rotation_no: 1,
								deep_clean: false
							}
						],
						expanded: true,
						order: 0
					};
				}
			};

			function init() {
				self.loading = true;
				if ($state.is('main.merrymaids.quote.read.update')) {
					$scope.MMJobMainCtrl.jobOrQuote = 'quote';
				} else if ($state.is('main.merrymaids.job.read')) {
					$scope.MMJobMainCtrl.jobOrQuote = 'job';
				}
				$q.all([
					read()
						.then(function () {
							self.job.converting = $state.is('main.merrymaids.quote.read.convert');
							MMJobSvc.updateRotationCounts(self.job);
							syncJobRoomsToCleanRotations();
							syncJobRoomsToDeepCleanRotations();
							angular.forEach(self.job.job_clean_frequencies, (jobCleanFrequency) => {
								jobCleanFrequency.tmp_discount_type = angular.copy(jobCleanFrequency.discount_type);
								jobCleanFrequency.tmp_discount_value = jobCleanFrequency.discount_value;
								jobCleanFrequency.tmp_discount_description = jobCleanFrequency.discount_description;
							});
							// if converting and there is only one clean frequency, pre-select it
							if (!self.job.converted && self.job.converting && self.job.job_clean_frequencies.length === 1) {
								angular.extend(self.job, {
									job_clean_frequency: {
										id: self.job.job_clean_frequencies[0].id
									}
								});
								self.job.job_clean_frequencies[0].expanded = true;
							}
							if (angular.isObject(self.job.job_clean_frequency)) {
								self.job.job_clean_frequency.tmp_discount_type = angular.copy(self.job.job_clean_frequency.discount_type);
								self.job.job_clean_frequency.tmp_discount_value = self.job.job_clean_frequency.discount_value;
								self.job.job_clean_frequency.tmp_discount_description = self.job.job_clean_frequency.discount_description;
							}
						}),
					setVatRate(),
					options()
				])
					.then(function () {
						initWatches();
						onJobDurationChange();
						if (angular.isObject(self.job.customer)) {
							onCustomerChange();
						}
						self.loading = false;
					});
			}

			function initWatches() {
				$scope.$watch(function () {
					return self.form.options.site;
				}, function (newVal, oldVal) {
					// if options have changed, unset site (unless previously undefined)
					if (angular.isArray(oldVal)) {
						self.job.site = null;
					}
					// if only one choice in new options, set site to that
					if (angular.isArray(newVal) && newVal.length === 1 && angular.isObject(self.job.site) !== true) {
						self.job.site = newVal[0];
					}
				});

				if (self.job.converted) {
					$scope.$watch(function () {
						return {
							frequency_start_date: self.job.frequency_start_date,
							job_clean_frequency: self.job.job_clean_frequency
						};
					}, function () {
						setCleanFrequencyAvailableDays(self.job.job_clean_frequency);
					}, true);
				}
				else {
					$scope.$watch(function () {
						return {
							frequency_start_date: self.job.frequency_start_date,
							job_clean_frequencies: self.job.job_clean_frequencies
						};
					}, function () {
						angular.forEach(self.job.job_clean_frequencies, function (jobCleanFrequency) {
							setCleanFrequencyAvailableDays(jobCleanFrequency);
						});
					}, true);
				}
			}

			function setCleanFrequencyAvailableDays(jobCleanFrequency) {
				$timeout(function () {
					$scope.$apply(function () {
						angular.extend(jobCleanFrequency, {
							clean_days_locked: true
						});
						if (!(self.job.converting || self.job.converted)) {
							angular.extend(jobCleanFrequency, {
								clean_days_locked: false
							});
							// TODO: Known bug - When already checked icheck gets re-enabled it stays grey (otherwise works)
						}
						else if (angular.isObject(jobCleanFrequency.cleaning_frequency)) {
							var cleaningFrequency = jobCleanFrequency.cleaning_frequency;
							var daily = cleaningFrequency.period === 'day';
							var weekly = cleaningFrequency.period === 'week' && cleaningFrequency.period_gap === 1;
							if (daily || weekly) {
								console.info('daily or weekly');
								angular.extend(jobCleanFrequency, {
									clean_days_locked: false
								});
							}
							else if (self.job.frequency_start_date) {
								console.info('NOT daily or weekly');
								angular.extend(jobCleanFrequency, {
									clean_days_locked: true
								});
								var date = moment(self.job.frequency_start_date, $scope.config.datePicker.basic.storageFormat);
								var dayOfWeek = parseInt(date.format('e'));
								// SUNDAY IS NOT THE FIRST DAY OF THE WEEK!
								// dayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
								angular.extend(jobCleanFrequency, {
									clean_mon: dayOfWeek === 0,
									clean_tue: dayOfWeek === 1,
									clean_wed: dayOfWeek === 2,
									clean_thu: dayOfWeek === 3,
									clean_fri: dayOfWeek === 4,
									clean_sat: dayOfWeek === 5,
									clean_sun: dayOfWeek === 6
								});
							}
						}

					});
				});
			}

			function syncJobRoomsToCleanRotations() {
				console.info('syncJobRoomsToCleanRotations');
				MMJobSvc.updateRotationCounts(self.job);
				// copy clean rotation working copy from job rooms
				self.cleanRotations = [];
				var i;
				var cleanRotation;
				for (i = 1; i <= self.job.clean_rotation_count; i++) {
					cleanRotation = {
						rotation_no: i,
						cleanRooms: []
					};
					// for each job room, fill in the model for the checkbox
					angular.forEach(self.job.job_rooms, function (jobRoom) {
						var clean = ($filter('filter')(jobRoom.clean_rotations, {rotation_no: i}, true)[0] || {}).clean == true;
						cleanRotation.cleanRooms.push({
							jobRoom: jobRoom,
							rotation_no: cleanRotation.rotation_no,
							clean: clean
						});
					});
					self.cleanRotations.push(cleanRotation);
				}
			}

			function syncCleanRotationsToJobRooms() {
				console.info('syncCleanRotationsToJobRooms');
				// copy clean rotation working copy to job rooms
				// clear rotations from each jobRoom
				angular.forEach(self.job.job_rooms, function (jobRoom) {
					jobRoom.clean_rotations = [];
				});
				// make new copy of rotations from working copy
				angular.forEach(self.cleanRotations, function (cleanRotation) {
					angular.forEach(cleanRotation.cleanRooms, function (cleanRoom, roomIndex) {
						self.job.job_rooms[roomIndex].clean_rotations.push({
							rotation_no: cleanRotation.rotation_no,
							clean: cleanRoom.clean
						});
					});
				});
			}

			function syncJobRoomsToDeepCleanRotations() {
				console.info('syncJobRoomsToDeepCleanRotations');
				MMJobSvc.updateRotationCounts(self.job);
				// copy clean rotation working copy from job rooms
				self.deepCleanRotations = [];
				var i;
				var deepCleanRotation;
				for (i = 1; i <= self.job.deep_clean_rotation_count; i++) {
					deepCleanRotation = {
						rotation_no: i,
						cleanRooms: []
					};
					// for each job room, fill in the model for the checkbox
					angular.forEach(self.job.job_rooms, function (jobRoom) {
						var deepClean = ($filter('filter')(jobRoom.deep_clean_rotations, {rotation_no: i}, true)[0] || {}).deep_clean == true;
						deepCleanRotation.cleanRooms.push({
							jobRoom: jobRoom,
							rotation_no: deepCleanRotation.rotation_no,
							deep_clean: deepClean
						});
					});
					self.deepCleanRotations.push(deepCleanRotation);
				}
			}

			function syncDeepCleanRotationsToJobRooms() {
				console.info('syncDeepCleanRotationsToJobRooms');
				// copy clean rotation working copy to job rooms
				// clear rotations from each jobRoom
				angular.forEach(self.job.job_rooms, function (jobRoom) {
					jobRoom.deep_clean_rotations = [];
				});
				// make new copy of rotations from working copy
				angular.forEach(self.deepCleanRotations, function (deepCleanRotation) {
					angular.forEach(deepCleanRotation.cleanRooms, function (cleanRoom, roomIndex) {
						self.job.job_rooms[roomIndex].deep_clean_rotations.push({
							rotation_no: deepCleanRotation.rotation_no,
							deep_clean: cleanRoom.deep_clean
						});
					});
				});
			}

			function updateNextJobPartCleanRotationNo() {
				if (angular.isObject(self.job.job_part_next)) {
					let cleanNo = parseInt(self.job.job_part_next.clean_no);
					let rotationCount = self.cleanRotations.length;
					let offset = parseInt(self.job.clean_rotation_offset) || 0;
					let firstCleanDeep = parseInt(self.job.first_clean_deep);
					let nextRotationNo;
					if (rotationCount >= 1) {
						if (firstCleanDeep && cleanNo === 0) {
							nextRotationNo = 0;
						}
						else {
							let amendedCleanNo = cleanNo + offset + (firstCleanDeep ? -1 : 0);
							nextRotationNo = amendedCleanNo % rotationCount;
							nextRotationNo = nextRotationNo > 0 ? nextRotationNo : rotationCount;
						}
					}
					self.job.job_part_next.clean_rotation_no = nextRotationNo;
				}
			}

			function updateNextJobPartDeepCleanRotationNo() {
				if (angular.isObject(self.job.job_part_next)) {
					let cleanNo = parseInt(self.job.job_part_next.clean_no);
					let rotationCount = self.deepCleanRotations.length;
					let offset = parseInt(self.job.deep_clean_rotation_offset) || 0;
					let firstCleanDeep = parseInt(self.job.first_clean_deep);
					let nextRotationNo;
					if (rotationCount >= 1) {
						if (firstCleanDeep && cleanNo === 0) {
							nextRotationNo = 0;
						}
						else {
							let amendedCleanNo = cleanNo + offset + (firstCleanDeep ? -1 : 0);
							nextRotationNo = amendedCleanNo % rotationCount;
							nextRotationNo = nextRotationNo > 0 ? nextRotationNo : rotationCount;
						}
					}
					self.job.job_part_next.deep_clean_rotation_no = nextRotationNo;
				}
			}

			function read() {
				var deferred = $q.defer();
				var promises = {};

				if ($state.is('main.merrymaids.quote.read.update') ||
					$state.is('main.merrymaids.quote.read.convert') ||
					$state.is('main.merrymaids.proformaQuote.read.update') ||
					$state.is('main.merrymaids.job.read.update')) {
					self.updating = true;
					promises.jobPromise = MMJobSvc.read($stateParams.jobId)
						.then(function (response) {
							self.job = angular.extend(protos.job(), response.data.job);
							self.jobOriginal = angular.copy(self.job);
							$scope.job = angular.copy(self.job);
							self.job.preferred_cleaning_time = moment(self.job.preferred_cleaning_time, 'HH:mm:ss');

							deferred.resolve(true);
						});

					$q.all(promises)
						.then(function (responses) {
							deferred.resolve(true);
						});
				}
				else {
					self.job = protos.job();
					self.jobOriginal = angular.copy(self.job);
					$scope.job = angular.copy(self.job);
					MMJobSvc.updateRotationCounts(self.job);

					if ($state.is('main.merrymaids.proformaQuote.create')) {
						self.job.proforma_quote = true;

						// if creating a proforma quote, load the enquiry and assign it to the job
						promises.enquiryPromise = EnquirySvc.read($stateParams.enquiryId)
							.then(function (response) {
								self.job.enquiry = response.data.enquiry;
								$scope.enquiry = angular.copy(self.job.enquiry);
								generateQuoteName();
							});

						$q.all(promises)
							.then(function (responses) {
								deferred.resolve(true);
							});
					}
					else if ($state.is('main.merrymaids.quote.create') && $stateParams.customerId) {
						promises.customerPromise = CustomerSvc.read($stateParams.customerId)
							.then(function (response) {
								self.job.customer = response.data.customer;
								$scope.customer = angular.copy(self.job.customer);
								generateQuoteName();
							});

						$q.all(promises)
							.then(function () {
								deferred.resolve(true);
							})
					}
					else {
						deferred.resolve(true);
					}
				}

				return deferred.promise;
			}

			function setVatRate() {
				return TaxHelperSvc.setVatRate();
			}

			function generateQuoteName() {
				// quote name should only be updated whilst editing a quote
				if (self.job.converted === false && self.job.converting === false) {
					// update quote name based on customer or enquiry
					if (angular.isObject(self.job.customer)) {
						var surname = self.job.customer.label.substring(self.job.customer.label.lastIndexOf(' ') + 1)
							.toUpperCase();
						self.job.quote_name = (surname + '-' + moment()
							.format('MMMM-D-YYYY')).toUpperCase();
					}
					else if (angular.isObject(self.job.enquiry)) {
						self.job.quote_name = (self.job.enquiry.last_name + '-' + moment()
							.format('MMMM-D-YYYY')).toUpperCase();
					}
					else {
						self.job.quote_name = '';
					}
				}
			}

			function addJobCleanFrequency() {
				self.job.job_clean_frequencies.push(protos.jobCleanFrequency());
			}

			function removeJobCleanFrequency(jobCleanFrequency) {
				if (angular.isDefined(jobCleanFrequency.id)) {
					// mark for deletion
					jobCleanFrequency.delete = true;
				}
				else {
					// not yet saved
					var jobCleanFrequencies = self.job.job_clean_frequencies;
					var index = jobCleanFrequencies.indexOf(jobCleanFrequency);
					jobCleanFrequencies.splice(index, 1);
				}
			}

			function toggleJobCleanFrequencyExpanded(jobCleanFrequency) {
				jobCleanFrequency.expanded = !jobCleanFrequency.expanded;
			}

			function addJobRoom() {
				self.job.job_rooms.push(protos.jobRoom());
				setRoomOrder();
				onHouseLayoutUpdated();
			}

			function removeJobRoom(jobRoom, reorder) {
				reorder = (reorder || angular.isUndefined(reorder)) ? true : false;
				// TODO: Require at least 1 room
				var jobRooms = self.job.job_rooms;
				var index = jobRooms.indexOf(jobRoom);
				jobRooms.splice(index, 1);
				if (reorder) {
					setRoomOrder();
				}
				onHouseLayoutUpdated();
			}

			function toggleJobRoomExpanded(jobRoom) {
				jobRoom.expanded = !jobRoom.expanded;
			}

			function setRoomOrder() {
				var jobRooms = self.job.job_rooms;
				var order = 0;
				angular.forEach(jobRooms, function (jobRoom) {
					jobRoom.order = order;
					order++;
				});
			}

			function addCleanRotation() {
				var cleanRotation = {
					cleanRooms: []
				};
				angular.forEach(self.job.job_rooms, function (jobRoom) {
					cleanRotation.cleanRooms.push({
						clean: false,
						jobRoom: jobRoom
					});
				});
				self.cleanRotations.push(cleanRotation);
				onCleanRotationsUpdated();
			}

			function removeCleanRotation(index) {
				// always require at least 1 clean rotation
				if (self.cleanRotations.length > 1) {
					self.cleanRotations.splice(index, 1);
					onCleanRotationsUpdated();
				}
			}

			function addDeepCleanRotation() {
				var deepCleanRotation = {
					cleanRooms: []
				};
				angular.forEach(self.job.job_rooms, function (jobRoom) {
					deepCleanRotation.cleanRooms.push({
						deep_clean: false,
						jobRoom: jobRoom
					});
				});
				self.deepCleanRotations.push(deepCleanRotation);
				onDeepCleanRotationsUpdated();
			}

			function removeDeepCleanRotation(index) {
				// always require at least 1 deep clean rotation
				if (self.deepCleanRotations.length > 1) {
					self.deepCleanRotations.splice(index, 1);
					onDeepCleanRotationsUpdated();
				}
			}

			function options() {
				return $q.all({
					customerOptions: CustomerSvc.options()
						.then(function (response) {
							self.form.options.customer = response.data.options;
						}),
					licenseOptions: LicenseOptionsSvc.license()
						.then(function (response) {
							self.form.options.license = response.data.options;
						}),
					cleaningFrequencyOptions: MMCleaningFrequencySvc.options()
						.then(function (response) {
							self.form.options.cleaningFrequency = response.data.options;
						}),
					preferredCleaningTimeTypeOptions: MMJobSvc.preferredCleaningTimeTypeOptions()
						.then(function (response) {
							self.form.options.preferredCleaningTimeType = response.data.options;
						}),
					quoteStatusOptions: QuoteStatusSvc.options()
						.then(function (response) {
							self.form.options.quoteStatus = response.data.options;
						}),
					houseTemplateOptions: MMHouseTemplateSvc.options()
						.then(function (response) {
							self.form.options.houseTemplate = response.data.options;
						}),
					roomTypeOptions: MMRoomTypeSvc.options()
						.then(function (response) {
							self.form.options.roomType = response.data.options;
						}),
					cleaningInstructionOptions: MMCleaningInstructionSvc.options()
						.then(function (response) {
							self.form.options.cleaningInstruction = response.data.options;
						}),
					securityTypeOptions: SecurityTypeSvc.options()
						.then(function (response) {
							self.form.options.securityType = response.data.options;
						}),
					paymentTypeOptions: PaymentTypeSvc.options()
						.then(function (response) {
							self.form.options.paymentType = response.data.options;
						}),
					teams: EmployeeTeamSvc.load()
						.then(function (response) {
							self.form.options.teams = response.data.week_days;
						}),
					discountTypeOptions: MMDiscountSvc.typeOptions()
						.then((response) => {
							self.form.options.discountType = response.data.discount_type_collection;
						}),
				});
			}

			function clearDiscount(jobCleanFrequency) {
				angular.extend(jobCleanFrequency, {
					discount_type: null,
					discount_value: 0,
					first_clean_discount_net: 0,
					first_clean_discount_vat: 0,
					first_clean_discount_gross: 0,
					discount_net: 0,
					discount_vat: 0,
					discount_gross: 0,
				});
			}

			function submit() {
				var allValid = false;
				if (self.form.validator.api.valid()) {
					if (self.job.job_clean_frequency && self.job.job_clean_frequency.id && (self.job.converting)) {
						angular.forEach(self.job.job_clean_frequencies,function(job_clean_frequency, k){
							if (job_clean_frequency.id == self.job.job_clean_frequency.id){
								if(job_clean_frequency.clean_mon || job_clean_frequency.clean_tue || job_clean_frequency.clean_wed || job_clean_frequency.clean_thu || job_clean_frequency.clean_fri || job_clean_frequency.clean_sat || job_clean_frequency.clean_sun ){
									allValid = true;
								}
							}
						});
					}else{
						allValid = true;
					}
					if(!allValid){
						notify({
							message: 'Please select one or more cleaning days for selected cleaning frequency',
							classes: 'error'
						});
						return;
					}
					self.form.submitted = true;
					MMJobSvc.save(self.job)
						.then(function (response) {
							var job = response.data.job;
							notify({
								message: 'Success'
							});
							if (job.converted) {
								$state.go('main.merrymaids.job.read', {jobId: job.id});
							}
							else if (job.proforma_quote) {
								$state.go('main.merrymaids.proformaQuote.read', {jobId: job.id});
							}
							else {
								$state.go('main.merrymaids.quote.read', {jobId: job.id});
							}
						}, function (errors) {
							angular.forEach(errors, function (error) {
								notify({
									message: error,
									classes: 'error'
								})
							});
						})
						.finally(function () {
							self.form.submitted = false;
						});
				}
			}

			function onEnquiryChange() {
				generateQuoteName();
			}

			function onCustomerChange() {
				if (self.job.converting || self.job.converted) {
					// converting, copy sales pipeline from customer to job
					self.job.sales_pipeline = self.job.customer.sales_pipeline;
				}
				else {
					if (angular.isObject(self.job.customer)) {
						self.form.processing = true;
						var promises = [
							SiteSvc.customerOptions(self.job.customer.id)
								.then(function (response) {
									self.form.options.site = response.data.options;
								})
						];
						if (parseInt(self.job.customer_id) !== parseInt(self.job.customer)) {
							// customer's not changed, restore original sales pipeline
							self.job.sales_pipeline = angular.copy(self.jobOriginal.sales_pipeline);
						}
						else {
							promises.push(SalesPipelineSvc.index({
								filter: {
									customer: self.job.customer.id
								}
							})
								.then(function (response) {
									self.job.sales_pipeline = response.data.sales_pipelines[0];
								}));
						}
						$q.all(promises)
							.then(function () {
								self.form.processing = false;
							});
					}
					else {
						self.job.sales_pipeline = null;
						self.form.options.site = [];
					}
					generateQuoteName();
				}
			}

			function onFirstCleanPriceChange(jobCleanFrequency) {
				console.info('onFirstCleanPriceChange');
				if (jobCleanFrequency.first_clean_price !== true) {
					jobCleanFrequency.first_clean_net = jobCleanFrequency.first_clean_vat = jobCleanFrequency.first_clean_gross = 0;
				}

				onApplyDiscountClicked(jobCleanFrequency);
			}

			function onFirstCleanNetChange(jobCleanFrequency) {
				console.info('onFirstCleanNetChange');
				if (isNaN(jobCleanFrequency.first_clean_net) === false) {
					jobCleanFrequency.first_clean_vat = TaxHelperSvc.vatFromNet(jobCleanFrequency.first_clean_net);
					jobCleanFrequency.first_clean_gross = TaxHelperSvc.grossFromNet(jobCleanFrequency.first_clean_net);
				}
				else {
					jobCleanFrequency.first_clean_net = jobCleanFrequency.first_clean_vat = jobCleanFrequency.first_clean_gross = 0;
				}
			}

			function onFirstCleanGrossChange(jobCleanFrequency) {
				console.info('onFirstCleanGrossChange');
				if (isNaN(jobCleanFrequency.first_clean_gross) === false) {
					jobCleanFrequency.first_clean_net = TaxHelperSvc.netFromGross(jobCleanFrequency.first_clean_gross);
					jobCleanFrequency.first_clean_vat = TaxHelperSvc.vatFromGross(jobCleanFrequency.first_clean_gross);
				}
				else {
					jobCleanFrequency.first_clean_net = jobCleanFrequency.first_clean_vat = jobCleanFrequency.first_clean_gross = 0;
				}
			}

			function onCleanNetChange(jobCleanFrequency) {
				console.info('onCleanNetChange');
				if (isNaN(jobCleanFrequency.clean_net) === false) {
					jobCleanFrequency.clean_vat = TaxHelperSvc.vatFromNet(jobCleanFrequency.clean_net);
					jobCleanFrequency.clean_gross = TaxHelperSvc.grossFromNet(jobCleanFrequency.clean_net);
				}
				else {
					jobCleanFrequency.clean_net = jobCleanFrequency.clean_vat = jobCleanFrequency.clean_gross = 0;
				}
			}

			function onCleanGrossChange(jobCleanFrequency) {
				console.info('onCleanGrossChange');
				if (isNaN(jobCleanFrequency.clean_gross) === false) {
					jobCleanFrequency.clean_net = TaxHelperSvc.netFromGross(jobCleanFrequency.clean_gross);
					jobCleanFrequency.clean_vat = TaxHelperSvc.vatFromGross(jobCleanFrequency.clean_gross);
				}
				else {
					jobCleanFrequency.clean_net = jobCleanFrequency.clean_vat = jobCleanFrequency.clean_gross = 0;
				}
			}

			function onApplyDiscountClicked(jobCleanFrequency) {
				console.info('onApplyDiscountClicked');
				let deferred = $q.defer();
				let discountType = jobCleanFrequency.tmp_discount_type;
				let discountValue = jobCleanFrequency.tmp_discount_value;
				let preDiscountCleanGross = jobCleanFrequency.clean_gross;
				let preDiscountFirstCleanGross = jobCleanFrequency.first_clean_gross;

				if (angular.isObject(discountType)) {
					// Discount type applied, use the service to calculate the discounts
					let firstCleanDiscountPromise = MMDiscountSvc.calculateDiscount({
						discount_type: discountType,
						discount_value: discountValue,
						gross: jobCleanFrequency.first_clean_gross,
						vat_rate: TaxHelperSvc.getRawVatRate(),
					});
					let standardCleanDiscountPromise = MMDiscountSvc.calculateDiscount({
						discount_type: discountType,
						discount_value: discountValue,
						gross: jobCleanFrequency.clean_gross,
						vat_rate: TaxHelperSvc.getRawVatRate(),
					});
					$q.all({
						firstCleanDiscount: firstCleanDiscountPromise,
						standardCleanDiscount: standardCleanDiscountPromise,
					})
						.then((responses) => {
							angular.extend(jobCleanFrequency, {
								pre_discount_clean_gross: preDiscountCleanGross,
								pre_discount_first_clean_gross: preDiscountFirstCleanGross,
								discount_type: angular.copy(discountType),
								discount_value: discountValue,
								first_clean_discount_net: responses.firstCleanDiscount.data.net_discount,
								first_clean_discount_vat: responses.firstCleanDiscount.data.vat_discount,
								first_clean_discount_gross: responses.firstCleanDiscount.data.gross_discount,
								discount_net: responses.standardCleanDiscount.data.net_discount,
								discount_vat: responses.standardCleanDiscount.data.vat_discount,
								discount_gross: responses.standardCleanDiscount.data.gross_discount,
							});
							console.info(jobCleanFrequency);
							deferred.resolve(jobCleanFrequency);
						}, (errors) => {
							deferred.reject(errors);
						});
				}
				else {
					// No discount type applied, clear discounts
					clearDiscount(jobCleanFrequency);
					deferred.resolve(jobCleanFrequency);
				}

				return deferred.promise;
			}

			function showProximityLocatorModal(){
				ProximitySvc.showLocatorModal(self.job.license, self.job.site.postcode);
			}

			function onHouseTemplateChange() {
				var job = self.job;
				var houseTemplate = self.job.house_template;
				$ngBootbox.confirm('Are you sure you want to do this? Choosing a template will modify the selected house layout.')
					.then(function () {
						// clear all job rooms
						job.job_rooms.length = 0;
						angular.forEach(houseTemplate.rooms, function (room) {
							var result = $filter('filter')(self.form.options.roomType, {id: room.id}, true);
							if (result.length) {
								job.job_rooms.push(angular.extend(protos.jobRoom(), {
									room: angular.copy(result[0]),
									instructions: angular.copy(result[0].cleaning_instructions),
									expanded: false
								}));
							}
						});
						setRoomOrder();
						onHouseLayoutUpdated();
					})
					.finally(function () {
						$timeout(function () {
							$scope.$apply(function () {
								self.job.house_template = null;
							});
						});
					});
			}

			function onJobRoomMoved($index) {
				console.info('onJobRoomMoved');
				self.job.job_rooms.splice($index, 1);
				setRoomOrder();
				onHouseLayoutUpdated();
			}

			function onJobRoomRoomChanged(jobRoom) {
				$timeout(() => {
					$scope.$apply(() => {
						jobRoom.instructions = [];
						if (jobRoom.room) {
							angular.extend(jobRoom.instructions, angular.copy(jobRoom.room.cleaning_instructions));
						}
					});
				});
			}

			function onHouseLayoutUpdated() {
				console.info('onHouseLayoutUpdated');
				syncJobRoomsToCleanRotations();
				syncJobRoomsToDeepCleanRotations();
			}

			function onCleanRotationMoved($index) {
				console.info('onCleanRotationMoved');
				self.cleanRotations.splice($index, 1);
				onCleanRotationsUpdated();
			}

			function onCleanRotationsUpdated() {
				console.info('onCleanRotationsUpdated');
				var number = 1;
				angular.forEach(self.cleanRotations, function (cleanRotation) {
					cleanRotation.rotation_no = number;
					number++;
				});
				self.job.clean_rotation_count = self.cleanRotations.length;
				syncCleanRotationsToJobRooms();
				updateNextJobPartCleanRotationNo();
			}

			function onCleanRotationOffsetChanged() {
				updateNextJobPartCleanRotationNo();
			}

			function onDeepCleanRotationMoved($index) {
				console.info('onDeepCleanRotationMoved');
				self.deepCleanRotations.splice($index, 1);
				onDeepCleanRotationsUpdated();
			}

			function onDeepCleanRotationsUpdated() {
				console.info('onDeepCleanRotationsUpdated');
				var number = 1;
				angular.forEach(self.deepCleanRotations, function (deepCleanRotation) {
					deepCleanRotation.rotation_no = number;
					number++;
				});
				self.job.deep_clean_rotation_count = self.deepCleanRotations.length;
				syncDeepCleanRotationsToJobRooms();
				updateNextJobPartDeepCleanRotationNo();
			}

			function onDeepCleanRotationOffsetChanged() {
				updateNextJobPartDeepCleanRotationNo();
			}

			function onJobDurationChange() {
				self.job.job_minutes = 0;
				self.job.job_minutes += parseInt(self.job.job_duration_hours) ? parseInt(self.job.job_duration_hours) * 60 : 0;
				self.job.job_minutes += parseInt(self.job.job_duration_mins) ? parseInt(self.job.job_duration_mins) : 0;

				self.job.job_minutes_first_in = 0;
				self.job.job_minutes_first_in += parseInt(self.job.job_duration_first_in_hours) ? parseInt(self.job.job_duration_first_in_hours) * 60 : 0;
				self.job.job_minutes_first_in += parseInt(self.job.job_duration_first_in_mins) ? parseInt(self.job.job_duration_first_in_mins) : 0;
			}

			function onAdditionalCostScheduleGrossChange() {
				self.job.additional_cost_schedule.net = TaxHelperSvc.netFromGross(self.job.additional_cost_schedule.gross);
				self.job.additional_cost_schedule.vat = TaxHelperSvc.vatFromGross(self.job.additional_cost_schedule.gross);
				self.job.additional_cost_schedule.vat_rate = TaxHelperSvc.getRawVatRate();
			}

			var self = $scope.MMJobSaveCtrl = {
				loading: false,
				updating: false,
				job: undefined,
				cleanRotations: [],
				deepCleanRotations: [],
				methods: {
					init: init,
					addJobCleanFrequency: addJobCleanFrequency,
					removeJobCleanFrequency: removeJobCleanFrequency,
					toggleJobCleanFrequencyExpanded: toggleJobCleanFrequencyExpanded,
					addJobRoom: addJobRoom,
					removeJobRoom: removeJobRoom,
					toggleJobRoomExpanded: toggleJobRoomExpanded,
					setRoomOrder: setRoomOrder,
					addCleanRotation: addCleanRotation,
					removeCleanRotation: removeCleanRotation,
					addDeepCleanRotation: addDeepCleanRotation,
					removeDeepCleanRotation: removeDeepCleanRotation,
					submit: submit
				},
				eventHandlers: {
					onEnquiryChange: onEnquiryChange,
					onCustomerChange: onCustomerChange,
					onFirstCleanPriceChange: onFirstCleanPriceChange,
					onFirstCleanNetChange: onFirstCleanNetChange,
					onFirstCleanGrossChange: onFirstCleanGrossChange,
					onCleanNetChange: onCleanNetChange,
					onCleanGrossChange: onCleanGrossChange,
					onApplyDiscountClicked: onApplyDiscountClicked,
					showProximityLocatorModal: showProximityLocatorModal,
					onHouseTemplateChange: onHouseTemplateChange,
					onJobRoomMoved: onJobRoomMoved,
					onJobRoomRoomChanged: onJobRoomRoomChanged,
					onCleanRotationMoved: onCleanRotationMoved,
					onCleanRotationsUpdated: onCleanRotationsUpdated,
					onCleanRotationOffsetChanged: onCleanRotationOffsetChanged,
					onDeepCleanRotationMoved: onDeepCleanRotationMoved,
					onDeepCleanRotationsUpdated: onDeepCleanRotationsUpdated,
					onDeepCleanRotationOffsetChanged: onDeepCleanRotationOffsetChanged,
					onJobDurationChange: onJobDurationChange,
					onAdditionalCostScheduleGrossChange: onAdditionalCostScheduleGrossChange,
				},
				form: {
					processing: false,
					submitted: false,
					options: {},
					validator: {
						config: {
							errorPlacement: function (error) {
								error.appendTo('#form-errors');
							},
							errorContainer: '#form-errors'
						},
						api: {}
					}
				}
			};

		}
	]);
